import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from '../icon/svg/loading-icon';
import {Percentage} from '../percentage/percentage';

import type {MetricKey} from './types';

export function getMetricDisplayValue(
    value: number | null | undefined,
    isDraft: boolean,
    isLoading?: boolean,
    withPercent?: boolean
) {
    // Return the loading icon if loading
    if (isLoading) {
        return <LoadingIcon size={25} fill={colors.greyLt} />;
    }

    // If the edition is a draft we want to display '–'
    if (isDraft) {
        return '–';
    }

    // If the value is undefined, we want to display 0 as the default
    if (!value) {
        return withPercent ? '0%' : '0';
    }

    // Otherwise return the value
    // @ts-expect-error
    return withPercent ? <Percentage value={value} /> : value;
}

export function getMetricTitle(key: MetricKey): string {
    switch (key) {
        case 'totalSentCount':
            return 'Recipients';
        case 'openRate':
            return 'Open rate';
        case 'clickRate':
            return 'Click rate';
        case 'responseRate':
            return 'Responses';
        default:
            return '';
    }
}
